import React from "react";
import Sidebar from "./left-side-bar";
import LocationHeader from "./location-header";
import EventContent from "./main-component";

const EventPage: React.FC = () => {
  return (
    <div className="bg-black min-h-screen md:grid grid-cols-1 lg:grid-cols-9">
      {/* Sidebar */}
      <Sidebar className="lg:col-span-2" />
      {/* Main Content Events feed*/}
      <div className="lg:col-span-7 p-4">
        <LocationHeader />
        <div className="flex-1 overflow-y-auto p-4">
          <EventContent />
        </div>
      </div>
    </div>
  );
};

export default EventPage;
